import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { OrderMasterApiService } from '../../services/order-master-api.service';
import {
  MASTER_ORDER_PAYMENT_METHODS,
  PaymentMethod,
  paymentMethodLabel,
} from '../../enum/payment-method.enum';

@Component({
  selector: 'app-payment-method-selector',
  templateUrl: './payment-method-selector.component.html',
  styleUrls: ['./payment-method-selector.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class PaymentMethodSelectorComponent implements OnInit, OnChanges {

  /** Methods to hide (e.g. pay_later when recording a payment). */
  @Input() exclude: PaymentMethod[] = [];
  @Input() title = 'Payment';
  @Input() value: PaymentMethod | null = null;
  @Output() valueChange = new EventEmitter<PaymentMethod>();

  public options: { value: PaymentMethod; label: string }[] = [];
  public loading = true;

  private availableMethods: PaymentMethod[] = [];

  constructor(private orderMasterApiService: OrderMasterApiService) {
  }

  ngOnInit() {
    void this.loadMethods();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['exclude'] && !changes['exclude'].firstChange) {
      this.applyOptions();
    }
  }

  select(method: PaymentMethod) {
    this.value = method;
    this.valueChange.emit(method);
  }

  private async loadMethods() {
    this.loading = true;
    try {
      const res = await this.orderMasterApiService.getPaymentMethods();
      const methods = res?.paymentMethods?.length
        ? res.paymentMethods
        : MASTER_ORDER_PAYMENT_METHODS.filter((m) => m !== PaymentMethod.CASH);
      this.setOptions(methods);
    } catch {
      this.setOptions(
        MASTER_ORDER_PAYMENT_METHODS.filter((m) => m !== PaymentMethod.CASH),
      );
    } finally {
      this.loading = false;
    }
  }

  private setOptions(methods: PaymentMethod[]) {
    this.availableMethods = methods;
    this.applyOptions();
  }

  private applyOptions() {
    const excluded = new Set(this.exclude);
    this.options = this.availableMethods
      .filter((m) => !excluded.has(m))
      .map((value) => ({ value, label: paymentMethodLabel(value) }));

    if (!this.options.length) {
      return;
    }
    if (!this.value || !this.options.some((o) => o.value === this.value)) {
      this.select(this.options[0].value);
    }
  }
}
